import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ErrorNavigationService {
  private readonly _router: Router = inject(Router);

  public async handleHttpError(error: HttpErrorResponse): Promise<void> {
    console.log('error handler', error);
    switch (error.status) {
      case 409: {
        switch (error.error?.code) {
          case 0: {
            console.log('default');
            // await this._router.navigate(['/access-denied']);
            break;
          }
          case 6: {
            await this._router.navigate(['/403']);
            break;
          }
          default: {
            console.log('default');
            // await this._router.navigate(['/something-went-wrong']);
            break;
          }
        }
        break;
      }
      case 401: {
        switch (error.error?.code) {
          case 33: {
            await this._router.navigate(['/choose-account'], { queryParams: { type: 'blocked' } });
            break;
          }
          case 34: {
            await this._router.navigate(['/choose-account'], { queryParams: { type: 'revoked' } });
            break;
          }
          case 43: {
            await this._router.navigate(['/403']);
            break;
          }
          case 44: {
            await this._router.navigate(['/access-denied']);
            break;
          }
          case 45: {
            await this._router.navigate(['/403']);
            break;
          }
          case 59: {
            await this._router.navigate(['/session-closed'], { queryParams: { reason: 'expired' } });
            break;
          }
          case 60: {
            await this._router.navigate(['/session-closed'], { queryParams: { reason: 'terminated' } });
            break;
          }
          default: {
            await this._router.navigate(['/401']);
            break;
          }
        }
        break;
      }
      case 403: {
        switch (error.error?.code) {
          case 46: {
            await this._router.navigate(['/access-denied']);
            break;
          }
          default: {
            await this._router.navigate(['/403']);
            break;
          }
        }
        break;
      }
      default: {
        await this._router.navigate(['/something-went-wrong']);
        break;
      }
    }
  }
}
